import { Navigate, type RouteObject } from "react-router-dom";

export const onboardingsRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Onboardings" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      { index: true, element: <Navigate replace to="merchants" /> },
      {
        path: "merchants",
        handle: { breadcrumb: "Merchants" },
        children: [
          { index: true, element: <Navigate replace to="all" /> },
          {
            path: "view/:merchantId",
            handle: { breadcrumb: "Details" },
            async lazy() {
              const { MerchantDetailPage } = await import(
                "./merchants/MerchantDetailPage"
              );
              return { Component: MerchantDetailPage };
            },
          },
          {
            path: "view/domain/:publicDomain",
            handle: { breadcrumb: "Configuration Details" },
            async lazy() {
              const { MerchantDetailPage } = await import(
                "./merchants/MerchantDetailPage"
              );
              return { Component: MerchantDetailPage };
            },
          },
          {
            path: ":tab",
            async lazy() {
              const { MerchantsPage } = await import(
                "./merchants/MerchantsPage"
              );
              return { Component: MerchantsPage };
            },
          },
        ],
      },
      {
        path: "analytics",
        handle: { breadcrumb: "Analytics" },
        children: [
          { index: true, element: <Navigate replace to="overview" /> },
          {
            path: "overview",
            handle: { breadcrumb: "Overview" },
            async lazy() {
              const { OverviewPage } = await import(
                "./analytics/overview/OverviewPage"
              );
              return { Component: OverviewPage };
            },
          },
          {
            path: "returns",
            handle: { breadcrumb: "Returns" },
            children: [
              { index: true, element: <Navigate replace to="overview" /> },
              {
                path: ":tab",
                async lazy() {
                  const { ReturnsAnalyticsPage } = await import(
                    "./analytics/returns/ReturnsAnalyticsPage"
                  );
                  return { Component: ReturnsAnalyticsPage };
                },
              },
            ],
          },
          {
            path: "oms",
            handle: { breadcrumb: "OMS" },
            async lazy() {
              const { OmsAnalyticsPage } = await import(
                "./analytics/oms/OmsAnalyticsPage"
              );
              return { Component: OmsAnalyticsPage };
            },
          },
        ],
      },
      {
        path: "configurations",
        handle: { breadcrumb: "Configurations" },
        children: [
          { index: true, element: <Navigate replace to="edit" /> },
          {
            path: "edit",
            async lazy() {
              const { ConfigurationsPage } = await import(
                "./configurations/ConfigurationsPage"
              );
              return { Component: ConfigurationsPage };
            },
          },
          {
            path: "all/:merchantId?/:product?",
            async lazy() {
              const { ConfigurationsPage } = await import(
                "./configurations/ConfigurationsPage"
              );
              return { Component: ConfigurationsPage };
            },
          },
        ],
      },
      {
        path: "leaderboard/:product?/:merchantId?",
        handle: { breadcrumb: "Leaderboard" },
        async lazy() {
          const { MyOnboardingsPage } = await import(
            "./my-onboardings/MyOnboardingsPage"
          );
          return { Component: MyOnboardingsPage };
        },
      },
    ],
  },
];
